import React from 'react';
import { Link } from 'react-router-dom';

//개발 테스트 전용 결과 표시 버튼 리스트
const ResultList = () => {
    return (
        <>
            <div className="part1">
                <div className="layout">
                    <div className="btn-area  start">
                        <Link to='/mbti/result/36'>ESTJ 포메라니안</Link>
                        <Link to='/mbti/result/37'>ESFP 닥스훈트</Link>
                        <Link to='/mbti/result/38'>ENTP 슈나우저</Link>
                        <Link to='/mbti/result/39'>ESTP 보더콜리</Link>
                        <Link to='/mbti/result/40'>ENFJ 푸들</Link>
                        <Link to='/mbti/result/41'>ESFJ 골든 리트리버</Link>
                        <Link to='/mbti/result/42'>ENFP 비글</Link>
                        <Link to='/mbti/result/43'>ENTJ 도베르만</Link>
                        <Link to='/mbti'>뒤로가기 </Link>
                    </div>
                </div>
                <div className="layout">
                    <div className="btn-area  start">
                        <Link to='/mbti/result/44'>ISTJ 터키쉬 앙고라</Link>
                        <Link to='/mbti/result/45'>ISFP 노르웨이숲</Link>
                        <Link to='/mbti/result/46'>INTP 스코티시 폴드</Link>
                        <Link to='/mbti/result/47'>ISTP 퍼그</Link>
                        <Link to='/mbti/result/48'>INFJ 스핑크스</Link>
                        <Link to='/mbti/result/49'>ISFJ 페르시안</Link>
                        <Link to='/mbti/result/50'>INTJ 먼치킨</Link>
                        <Link to='/mbti/result/51'>INFP 러시안 블루</Link>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ResultList;